import * as css from './PaymentForm.css';
import {useTranslation} from 'react-i18next';
import SettingItem from '../settingItem/SettingItem';
import {useSelector} from 'react-redux';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {useNavigate} from 'react-router-dom';
import AccountPermission from '../../components/accountPermission/AccountPermission';
import DateInput from '../../../component/input/dateInput/DateInput';
import EventRolePermission from '../../components/rolePermission/EventRolePermission';
import {permissionToCamelCase} from '../../package/componnent/upgradePopup/UpgradePopup';
import CustomerConfirmationInputList from './CustomerConfirmationInputList';
import {hasMasterUserPermission} from '../../../functions/permission';
import {createSettingInputs} from '../commonSettingInputs';
import SubSettingItem from '../subSettingItem/SubSettingItem';
import Button from '../../../component/button/button/Button';
import Input from '../../../component/input/Input';
import {updateEventSettings} from '../../../redux/event/eventActions';

function PaymentForm({close}) {
    const {t} = useTranslation('event');
    const cancelPermissions = useSelector(state => state.account.permissions)?.find(p => permissionToCamelCase(p.permission) === 'userCancelTicket');
    const payments = useSelector(state => state.event.settings?.payments);
    const billings = useSelector(state => state.event.settings?.billings);
    const access = useSelector(state => state.event.settings?.access);
    const suspended = useSelector(state => state.event.settings?.suspended||{});
    const settingsXHR = useSelector(state => state.forms.eventSettings);
    let maxPaymentsList = [...Array(11).keys()].map(item => ({text: item + 2, key: item + 2}));
    let maxBillingsList = [...Array(35).keys()].map(item => ({text: item + 2, key: item + 2}));
    let cancelTicketListAfter = [...Array(14).keys()].map(item => ({text: item + 1, key: item + 1}));
    let cancelTicketListBefore = [...Array(7).keys()].map(item => ({text: item + 1, key: item + 1}));
    if(hasMasterUserPermission('cancel days after order max')){
        cancelTicketListAfter = [...Array(100).keys()].map(item => ({text: item + 1, key: item + 1}));
        cancelTicketListBefore = [...Array(8).keys()].map(item => ({text: item, key: item}));
    }
    if(hasMasterUserPermission('allow extended payments plan')){
        maxPaymentsList = [...Array(35).keys()].map(item => ({text: item + 2, key: item + 2}));
	    maxBillingsList = [...Array(99).keys()].map(item => ({text: item + 2, key: item + 2}));

    }
    // cancelTicketListAfter.unshift({text: t('always'), key: -1});
    // cancelTicketListBefore.unshift({text: t('always'), key: -1});
    const {getAmountInput, getToggle, getList} = createSettingInputs(billings, 'billings', settingsXHR, t, css);
    const suspendedInputs = createSettingInputs(suspended, 'suspended', settingsXHR, t, css);
    const paymentsInputs = createSettingInputs(payments, 'payments', settingsXHR, t, css);
    const cancelOrdersInputs = createSettingInputs(access, 'access', settingsXHR, t, css);
    const navigate = useNavigate();

    const ticketsClick = () => {
        navigate('tickets');
        close();
    };
    const validationSchema = Yup.object().shape(
        {
            minForPayments: Yup.number(),
            maxPayments: Yup.number().min(2).max(12),
            minSumBillings: Yup.number(),
            maxBillings: Yup.number().min(2).max(12),
        });

    const initialValues = {
        minForPayments: payments?.minForPayments,
        maxPayments: payments?.maxPayments,
        minSumBillings: billings?.minSumBillings,
        maxBillings: billings?.maxBillings,
        activateAuto: suspended.activateAuto||'manual',
        customerConfirmationData: suspended.customerConfirmationData,
        customerConfirmationActivate: suspended.customerConfirmationActivate||'manual',
        activateTime: suspended.activateTime,
        customerConfirmation: suspended.customerConfirmation||0,
        cancelDaysBeforeEvent: access?.cancelDaysBeforeEvent ?? 7,
        cancelDaysAfterOrder: access?.cancelDaysAfterOrder ?? 14,
    };

    const activateAutoList = [{key: 'date', text: 'byDate'}, {key: 'auto', text: 'activateWhenAllSold'}, {key: 'manual', text: 'manual'}];

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
        >
            <Form>
                <EventRolePermission rolePermission={'manage event'}>
                    <AccountPermission permission="event cash">
                        <SettingItem settingCategory='event' name='paycash' permission='event cash' rolePermission='manage event' />
                    </AccountPermission>
                    <AccountPermission permission="billing">
                        <SettingItem settingCategory='billings' name='hasBillings' permission='billing' rolePermission='manage event' >
                            {getAmountInput('minSumBillings')}
                            {getList('maxBillings', maxBillingsList)}
                            {getToggle('ticketsPayments')}
                            {getToggle('ticketsPaymentsLock')}
                            <SubSettingItem text={t('ticketsPaymentsList')}>
                                <Button BtnProps={{text: t('tickets'), onClick: ticketsClick, width: 70, height: '20px', backgroundColor: '#222'}} />
                            </SubSettingItem>
                        </SettingItem>
                    </AccountPermission>
                    <AccountPermission permission="payments">
                        <SettingItem settingCategory={'payments'} name={'hasPayments'} permission="payments" rolePermission='manage event'>
                            {paymentsInputs.getAmountInput('minForPayments')}
                            {paymentsInputs.getList('maxPayments', maxPaymentsList)}
                        </SettingItem>
                    </AccountPermission>
                    <AccountPermission permission='suspended'>
                        <SettingItem name={'susStatus'} settingCategory={'suspended'} permission="suspended" >
                            {suspendedInputs.getList('activateAuto', activateAutoList)}
                            {suspended.activateAuto === 'date' &&
                            <SubSettingItem text={t('activateTime')}>
                                <css.input>
                                    <DateInput
                                        name='activateTime'
                                        className={settingsXHR?.activateTimeXHR}
                                        onChange={val => updateEventSettings('activateTime', val, 'suspended')} />
                                </css.input>
                            </SubSettingItem>}
                        </SettingItem>

                        <AccountPermission permission='suspended'>
                            <AccountPermission permission='customer confirmation'>
                                <SettingItem name={'customerConfirmation'} settingCategory={'suspended'} permission="customer confirmation" >
                                    <SubSettingItem text={t('customerConfirmationActivate')}>
                                        <css.input>
                                            <CustomerConfirmationInputList
                                                name='customerConfirmationActivate'
                                                t={t}
                                                settingsXHR={settingsXHR}
                                            />
                                        </css.input>
                                    </SubSettingItem>
                                    {suspended.customerConfirmationActivate === 'time' &&
                            <SubSettingItem text={t('customerConfirmationDataTime')}>
                                <css.input>
                                    <DateInput
                                        name='customerConfirmationData.time'
                                        className={settingsXHR?.customerConfirmationDataXHR}
                                        onChange={val => updateEventSettings('customerConfirmationData', JSON.stringify({time:val, amount:suspended.customerConfirmationData?.amount||null}), 'suspended')} />
                                </css.input>
                            </SubSettingItem>}
                                    {suspended.customerConfirmationActivate === 'amount' &&
                                <SubSettingItem text={t('customerConfirmationDataAmount')}>
                                    <css.input>
                                        <Input name={'customerConfirmationData.amount'}
                                            events={{onBlur: (name, val) => updateEventSettings('customerConfirmationData', JSON.stringify({amount: val, time:suspended.customerConfirmationData?.time||null}), 'suspended')}} className={settingsXHR?.customerConfirmationDataXHR}  />
                                    </css.input>
                                </SubSettingItem>}
                                </SettingItem>

                            </AccountPermission>
                        </AccountPermission>
                    </AccountPermission>
                    {cancelPermissions?.status==1&&<AccountPermission permission="user cancel ticket">
                        <SettingItem settingCategory={'access'} name={'userCancelTicket'} permission="user cancel ticket" rolePermission='manage event'>
                            {cancelOrdersInputs.getList('cancelDaysBeforeEvent',cancelTicketListBefore,undefined, true )}
                            {cancelOrdersInputs.getList('cancelDaysAfterOrder',cancelTicketListAfter,undefined, true)}
                        </SettingItem>
                    </AccountPermission>}
                </EventRolePermission>
            </Form>
        </Formik>);
}

export default PaymentForm;
